<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="排产明细"
      width="1200px"
      top="10vh"
      class="task-preview"
      @close="$reset('form')">
    <el-form
        ref="form"
        class="form"
        label-width="600px"
        height="600px"
    >
      <Table
          height="600px"
          :data="taskDetail"
          :columns="columns"
          module="basic"
          stripe
          border/>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "TaskPreview",
    data() {
      return {
        dialogVisible: false,
        taskDetail: [],
        columns: [
          {
            type: "expand",
            width: 55,
            render: (h, params) => {
              return h("Table", {
                props: {
                  data: params.row.purchaseOrderDetailVOS,
                  columns: [
                    {
                      title: "采购单号",
                      key: "purchaseOrderNo",
                      width: 180,
                    },
                    {
                      title: "物料编号",
                      key: "materialNo",
                      width: 160,
                    },
                    {
                      title: "物料名称",
                      key: "materialName",
                      width: 140,
                    },
                    {
                      title: "规格型号",
                      key: "specification",
                      width: 160,
                    },
                    {
                      title: "需求数量",
                      key: "qty",
                      width: 140,
                    },
                    {
                      title: "入库数量",
                      key: "sendedQuantity",
                      width: 140,
                    },
                    {
                      title: "要求交期",
                      key: "deliveryDate",
                      width: 140,
                    },
                    {
                      title: "最终交期",
                      key: "finalDeliveryDate",
                      width: 140,
                    },
                    {
                      title: "入库时间",
                      key: "createTime",
                      width: 140,
                    },
                  ],
                  border: true,
                  stripe: true,
                },
              });
            },
          },
          {
            title: "下单时间",
            key: "orderDate",
            width: 160,
          },
          {
            title: "物料编号",
            key: "materialNo",
            width: 160,
          },
          {
            title: "客户名称",
            key: "customerName",
            width: 160,
          },
          {
            title: "物料名称",
            key: "materialName",
            width: 140,
          },
          {
            title: "规格型号",
            key: "specification",
            width: 200,
          },
          {
            title: "派工单号",
            key: "billNo",
            width: 140,
          },
          {
            title: "到料状态",
            key: "inStockStatus",
            width: 100,
            align: "center",
          },
        ],
      };
    },
    computed: {},

    methods: {
      open(row) {
        this.dialogVisible = true;
        this.taskDetail = row;
        console.log(row);
      },
    },
  };
</script>

<style lang="scss">
.task-preview .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.task-preview .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.task-preview .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.task-preview .el-divider--horizontal {
  margin: 10px 0;
}

.task-preview .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.task-preview .childMetrialTable .el-input__inner {
  text-align: center;
}

.task-preview .childMetrialTable .price .el-input__inner {
  text-align: left;
}
</style>